import React from 'react';
import PropTypes from 'prop-types';
import Table from 'components/shared/table';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const GradingStationTableHeader = props => {
  const { columns } = props;

  return (
    <Table.Header>
      {columns.map((header, i) => (
        <Table.Header.Cell key={header} center>
          <Text variant={TEXT_VARIANTS.BODY_BOLD}>{header}</Text>
        </Table.Header.Cell>
      ))}
    </Table.Header>
  );
};

GradingStationTableHeader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string),
};

export default GradingStationTableHeader;
